import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcEditFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.7 3.533a1.75 1.75 0 0 0-2.476 0L4.743 15.016a2.75 2.75 0 0 0-.718 1.253l-.98 3.772a.75.75 0 0 0 .915.915l3.772-.98a2.75 2.75 0 0 0 1.253-.718l8.298-8.297.027-.028 3.157-3.157a1.75 1.75 0 0 0 0-2.475zm-1.594 5.483 2.3-2.301a.25.25 0 0 0 0-.353L17.64 4.594a.25.25 0 0 0-.354 0l-2.3 2.3z",
    clipRule: "evenodd"
  }));
}
var IcEditFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcEditFill));

export { IcEditFill as I };
